export const navigation = {
  about: "About",
  activities: "Activity log",
  administration: "Administration",
  assets: "Assets",
  assetTypes: "Asset types",
  browse: "Browse by",
  collapse: "Collapse",
  dashboard: "Dashboard",
  events: "My events",
  expand: "Expand",
  import: "Import tool",
  interventions: "Interventions",
  interventionTemplates: "Intervention templates",
  language: "Language",
  locations: "Locations",
  logout: "Logout",
  mySpace: "My space",
  observations: "Observations",
  organizations: "Organizations",
  pageError: {
    notFound: {
      title: "Page not found",
      description: "The page «{{path}}» doesn't exist.",
    },
    default: {
      title: "An error occurred",
    },
    returnToDashboard: "Go back to dashboard",
    returnToLogin: "Go back to login",
  },
  password: "Change password",
  preferences: "Preferences",
  projects: "Projects",
  support: "Support",
  technicalForms: "Technical forms",
  users: "Users",
};
